export const ReceiptEuro20Icon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props,
) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      {...props}
    >
      <g>
        <path
          d="M15.8335 6.66671H19.1668V2.50004C19.1668 1.57957 18.4206 0.833374 17.5002 0.833374V0.833374C16.5797 0.833374 15.8335 1.57957 15.8335 2.50004V19.1667L13.3335 18.3334L10.8335 19.1667L8.3335 18.3334L5.8335 19.1667L3.3335 18.3334L0.833496 19.1667V2.83337C0.833496 1.7288 1.72893 0.833374 2.83349 0.833374L17.5002 0.833374"
          strokeWidth="1.67"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M4.1665 15H12.4998" strokeWidth="1.67" strokeLinecap="round" />
        <path
          d="M11.4585 5.20829C10.9228 4.67264 10.2404 4.30785 9.49739 4.16006C8.75441 4.01227 7.98429 4.08812 7.28442 4.37802C6.58455 4.66791 5.98636 5.15884 5.5655 5.7887C5.14464 6.41857 4.92 7.15909 4.92 7.91663C4.92 8.67416 5.14464 9.41468 5.5655 10.0445C5.98636 10.6744 6.58455 11.1653 7.28442 11.4552C7.98429 11.7451 8.75441 11.821 9.49739 11.6732C10.2404 11.5254 10.9228 11.1606 11.4585 10.625"
          strokeWidth="1.67"
          strokeLinecap="round"
        />
        <path
          d="M3.75 6.66663L7.91667 6.66663"
          strokeWidth="1.67"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.75 9.16663L7.91667 9.16663"
          strokeWidth="1.67"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};
